import { Typography, Grid, Paper, Box, Button } from "@mui/material";
import { useEffect } from "react";
import { FieldValues, useForm } from "react-hook-form";
import AppDropzone from "../../app/components/AppDropzone";
import AppSelectList from "../../app/components/AppSelectList";
import AppTextInput from "../../app/components/AppTextInput";
//import useProducts from "../../app/hooks/useProducts";
import usePumpTransactions from "../../app/hooks/usePumpTransactions";
//import { Product } from "../../app/models/product";
import { PumpTransaction } from "../../app/models/pumpTransaction";
import { yupResolver } from '@hookform/resolvers/yup';
import { validationSchema } from "./pumpTransactionValidation";
import agent from "../../app/api/agent";
import { useAppDispatch } from "../../app/store/configureStore";
import { setPumpTransaction } from "../pump-transactions/pumpTransactionSlice";
import { LoadingButton } from "@mui/lab";
import AppCheckbox from "../../app/components/AppCheckbox";
import AppDatePicker from "../../app/components/AppDatePicker";
import { currencyFormat, dateFormat, dateFormatReset } from "../../app/util/util";
import { toast } from "react-toastify";

interface Props {
    pumpTransaction?: PumpTransaction;
    cancelEdit: () => void;
}

export default function PumpTransactionForm({ pumpTransaction, cancelEdit }: Props) {
    const { control, reset, handleSubmit, watch, formState: { isDirty, isSubmitting } } = useForm({
        mode: 'all',
        resolver: yupResolver<any>(validationSchema)
    });
    //const { brands, types } = useGasStations();
    const watchFile = watch('file', null);
    const dispatch = useAppDispatch();
    
    useEffect(() => {
        if (pumpTransaction && !watchFile && !isDirty) reset(pumpTransaction);
        return () => {
            if (watchFile) URL.revokeObjectURL(watchFile.preview);
        }
    }, [pumpTransaction, reset, watchFile, isDirty]);

    async function handleSubmitData(data: FieldValues) {
        let response: any;
        try {
            
            data.transactionDate = dateFormatReset(data.transactionDate);
            if (pumpTransaction) {
                response = await agent.PumpTransaction.patch(data.gasStationId, data.id, data);
            } else {
                response = await agent.PumpTransaction.post(data.gasStationId, data);
            }
            dispatch(setPumpTransaction(response));
            toast.success(response.message?.toString() || 'Success!');
            cancelEdit();
        } catch (error) {
            console.log(error);
            toast.error(error?.toString() || 'Error occurred.');
        }
    }

    return (
        <Box component={Paper} sx={{ p: 4 }}>
            <Typography variant="h5" gutterBottom sx={{ mb: 4, letterSpacing: '1px' }}>
                PumpTransaction Details
            </Typography>
            <form onSubmit={handleSubmit(handleSubmitData)}>
                <Grid container spacing={3}>
                    
                    <Grid item xs={12} sm={6}>
                        <AppTextInput control={control} name='pumpNumber' label='Pump Number' />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <AppDatePicker control={control} name='transactionDate' label='Transaction Date' />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <AppTextInput type='number' control={control} name='beginningLiters' label='Beginning Liters' />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <AppTextInput type='number' control={control} name='endingLiters' label='Ending Liters' />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <AppTextInput type='number' control={control} name='saleAmount' label='Sale Amount' />
                    </Grid>
                </Grid>
                <Box display='flex' justifyContent='space-between' sx={{ mt: 3 }}>
                    <Button onClick={cancelEdit} variant='contained' color='inherit'>Cancel</Button>
                    <LoadingButton loading={isSubmitting} type='submit' variant='contained' color='success'>Submit</LoadingButton>
                </Box>
            </form>
        </Box>
    )
}